<template>
  <div class="tile is-vertical is-parent is-3">
    <a v-for="item in images" v-bind:item="item" :key="item.filename" :href="item.filename">
      <img :src="item.filename_thumbnail||item.filename" :alt="item.filename_thumbnail||item.filename" />
    </a>
  </div>
</template>

<script>

export default {
  props: ['images']
}

</script>
